 <template>
    <div>
        <el-input
            v-model="selectName"
            @focus="DialogOpend"
            @clear="SelectClear"
            size="mini"
            placeholder="筛选项目"
            clearable
            :style="{ width: width, margin: margin }"/>

        <el-dialog :visible.sync="dialogVisible" class="w-el-dialog" width="900px" append-to-body title="选择项目（双击选择）" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="w-vxe-fullscreen w-padding-none" style="height: 600px;">
                <div class="w-vxe-flex" style="border-radius: 0; box-shadow: none; padding: 0;">

                    
                    <uw-table>

                        
                        <template slot="search">
                            <el-input v-model="search.number" clearable size="mini" placeholder="请输入项目编号" @keyup.enter.native="handleInputSearch('number')" @blur="handleInputSearch('number')" @clear="handleInputSearch('number')"></el-input>
                            <el-input v-model="search.name" clearable size="mini" placeholder="请输入项目名称" @keyup.enter.native="handleInputSearch('name')" @blur="handleInputSearch('name')" @clear="handleInputSearch('name')"></el-input>
                        </template>

                        
                        <template slot="data">
                            <vxe-table ref="xTable" :data="table" :loading="dialogLoading" @sort-change="TableSort" @cell-dblclick="TableCellDblclick" height="100%">
                        
                                
                                <vxe-column width="60" field="id" title="ID" sortable></vxe-column>

                                
                                <vxe-column width="150" field="number" title="项目编号" sortable>
                                    <template #default="{ row }">
                                        <el-link @click="ProjectsManage(row.id)" icon="el-icon-link" type="primary"><b><span class="w-color-black">{{ row.number }}</span></b></el-link>
                                    </template>
                                </vxe-column>

                                
                                <vxe-column min-width="250" field="name" title="项目名称" sortable>
                                    <template #default="{ row }">
                                        
                                        <el-tag v-if="row.status == 1" size="mini" effect="dark">进行中</el-tag>
                                        <el-tag v-if="row.status == 2" size="mini" effect="dark" type="warning">已暂停</el-tag>
                                        <el-tag v-if="row.status == 4" size="mini" effect="dark" type="info">已关闭</el-tag>
                                        <el-tag v-if="row.status == 5" size="mini" effect="dark" type="success">待验收</el-tag>
                                        
                                        <el-tag style="margin-left: 5px;" v-if="row.is_overdue" size="mini" effect="dark" type="danger">已延期</el-tag>
                                        
                                        {{ row.name }}
                                    </template>
                                </vxe-column>

                                
                                <vxe-column width="120" field="leader_object.user.name" title="项目经理">
                                    <template #default="{ row }">
                                        <div style="display: flex; align-items: center; justify-content: flex-start;" v-if="row.leader_object?.user">
                                            <el-avatar style="margin-right: 5px;" :size="26" v-if="row.leader_object?.user.avatar" :src="row.leader_object?.user.avatar" />
                                            <el-avatar style="margin-right: 5px;" :size="26" v-else> {{ row.leader_object?.user.name[0] }} </el-avatar>
                                            {{  row.leader_object?.user.name }}
                                        </div>
                                    </template>
                                </vxe-column>

                                
                                <vxe-column width="120" field="sale_object.user.name" title="项目销售">
                                    <template #default="{ row }">
                                        <div style="display: flex; align-items: center; justify-content: flex-start;" v-if="row.sale_object?.user">
                                            <el-avatar style="margin-right: 5px;" :size="26" v-if="row.sale_object?.user.avatar" :src="row.sale_object?.user.avatar" />
                                            <el-avatar style="margin-right: 5px;" :size="26" v-else> {{ row.sale_object?.user.name[0] }} </el-avatar>
                                            {{  row.sale_object?.user.name }}
                                        </div>
                                    </template>
                                </vxe-column>

                            </vxe-table>
                        </template>

                        
                        <template slot="pager">
                            <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
                        </template>

                    </uw-table>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Array, Number],
            default: null
        },

        width: {
            type: String,
            default: '100%'
        },

        margin: {
            type: String,
            default: '0px'
        },
        customSearch: {
          type: Object,
          default: () => ({}) // 默认为空对象
        }
    },

    data () {
        return {
            dialogVisible: false,
            dialogLoading: false,

            table: [],

            page: {
                total: 0,
                size: 50,
                current: 1,
            },

            search: {
                is_overdue: null,
                number: null,
                name: null,
                ...this.customSearch
            },

            lastSearchedInput: {
                number: '',
                name: '',
            },

             order: {
                method: 'desc',
                column: 'id'
            },

            selectObject: {},
            selectName: null
        }
    },

    watch: {
        value: {
            handler(val) {
                if (val) {
                    this.$http.post('/9api/projects/search-first', { id: val, hidden: ['describe'] }).then(rps => {
                        this.selectName =  rps.data.name
                        this.selectObject = rps.data
                    })
                } else {
                    this.selectObject = {}
                    this.selectName = null
                }
            },
            immediate: true
        },
    },

    methods: {
        DialogOpend() {
            this.dialogVisible = true
            this.TableSearch()
        },
        syncSearchInputSnapshot() {
            this.lastSearchedInput.number = this.search.number ?? ''
            this.lastSearchedInput.name = this.search.name ?? ''
        },
        handleInputSearch(field) {
            const value = this.search[field] ?? ''
            const lastValue = this.lastSearchedInput[field] ?? ''
            if (value !== lastValue) {
                this.TableSearch()
            }
        },
        TableSearch() {
            this.syncSearchInputSnapshot()
            this.dialogLoading = true
            this.$http.post(
                '/9api/projects/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    append: ['leader_object', 'sale_object'],
                    hidden: ['describe']

                }
            ).then((rps) => {
                this.page.total = rps.data.total
                this.table = rps.data.body

                 if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }

                this.dialogLoading = false
            })
        },
        TableSort(column) {
            this.order.method = column.order ? column.order : this.order.method
            this.order.column = column.field
            this.TableSearch()
        },
        TableCellDblclick({ row }) {
            this.SelectChange(row)
        },
        SelectClear() {
            this.selectName = null
            this.selectObject = {}
            this.$emit('input', null)
            this.$emit('onChange', null)
        },
        SelectChange(item) {
            this.selectName =  item.name
            this.selectObject = item
            this.$emit('input', item.id)
            this.$emit('onChange', item)
            this.dialogVisible = false
        },
    }
}
</script>